export default {
  PhoneCountryCodeFormField__ARIA: "Country code",
  PhoneCountryCodeFormField__LABEL: "Country/Country code",
};
